import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import {
  DashboardHome,
  ErrorPage,
  AccountPage,
  KycProgress,
  PlanSelection,
  ConfirmationPage,
  PlanSuccess,
  RefundPage,
  RefundSetting,
  MyInvoices,
  CurrentUsages,
  RefundConfirmation,
  CreateGiftCard,
  RefundList,
  GiftCardsList,
  ResendGiftCard,
  TermsConditions,
  PrivacyPolicy,
  FaqPage,
  Issues,
  PaymentFailed,
  LoggedOut,
} from "../pages";
import GiftCardDetail from "../pages/issuance/GiftCardDetail";
import EditGiftCard from "../pages/issuance/EditGiftCard";
import EditPhysicalGiftCard from "../pages/issuance/EditPhysicalGiftCard";
import CreatePhysicalGC from "../pages/issuance/CreatePhyicalGC";
import PhysicalGiftCardOrder from "../pages/issuance/PhysicalGiftCardOrder";
import ProtectedRoute from "../components/ProtectedRoutes/ProtectedRoute";
import { isUserAuthenticated } from "../utils/userAuthenticate";
import ManageTemplates from "../pages/issuance/EmailTemplates";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <DashboardHome />,
      },
      {
        path: "/home",
        element: <DashboardHome />,
      },
      {
        path: "/payment/success",
        element: <PlanSuccess />
      },
      {
        path: "/my-account",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <AccountPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/my-invoices",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <MyInvoices />
          </ProtectedRoute>
        ),
      },
      {
        path: "/current-usage",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <CurrentUsages />
          </ProtectedRoute>
        ),
      },
      {
        path: "/kyc-status",
        element: <KycProgress />,
      },
      {
        path: "/manage-templates",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <ManageTemplates />
          </ProtectedRoute>
        )
      },
      {
        path: "/create-physical-gift-card",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <CreatePhysicalGC />
          </ProtectedRoute>
        ),
      },
      {
        path: "/create-giftcard",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <CreateGiftCard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/my-gift-card",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <GiftCardsList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/my-gift-card/:id",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <GiftCardDetail />
          </ProtectedRoute>
        ),
      },
      {
        path: "/edit-gift-card/:id",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <EditGiftCard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/edit-physical-gift-card/:id",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <EditPhysicalGiftCard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/resend-gift-card",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <ResendGiftCard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/physical-gift-card-orders",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <PhysicalGiftCardOrder />
          </ProtectedRoute>
        ),
      },
      // NEW: Route for fulfill view with order ID
      {
        path: "/physical-gift-card-orders/fulfill/:orderId",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <PhysicalGiftCardOrder />
          </ProtectedRoute>
        ),
      },
      {
        path: "/refunds",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <RefundList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/refunds/:id",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <RefundPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/configuration",
        element: (
          <ProtectedRoute isAuthenticated={isUserAuthenticated}>
            <RefundSetting />
          </ProtectedRoute>
        ),
      },
      {
        path: "/terms-and-conditions",
        element: <TermsConditions />,
      },
      {
        path: "/faqs",
        element: <FaqPage />,
      },
      {
        path: "/issues",
        element: <Issues />,
      },
      { path: "/refund_success", element: <RefundConfirmation /> },
      { path: "/payment-unsuccessful", element: <PaymentFailed /> },
      {
        path: "/log-out",
        element: <LoggedOut />,
      },
    ],
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  { path: "/select-plan", element: <PlanSelection /> },
  { path: "/submission_success", element: <ConfirmationPage /> },
]);

export default router;